import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "handDollar"
const HandDollarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.683 14.489c.493 0 .894.4.894.894v5.723c0 .493-.4.894-.894.894H3.894A.894.894 0 0 1 3 21.106v-5.723c0-.494.4-.894.894-.894zM11.763 14.488c1.172 0 2.165.752 2.53 1.799l-.11.07a5 5 0 0 1-2.436.636h-.341a.537.537 0 0 0 0 1.073h.341a6.06 6.06 0 0 0 2.97-.779l.011-.005.01-.007 3.46-2.155a2 2 0 0 1 1.636-.221c.233.128.444.306.602.544.323.484.285 1.033.13 1.473-.154.438-.444.84-.758 1.13l-2.523 2.343A6.03 6.03 0 0 1 13.183 22h-.88a8.3 8.3 0 0 1-2.615-.425l-2.038-.679V15.41l1.123-.561c.472-.236.992-.36 1.52-.36z" />
          <path
            fillRule="evenodd"
            d="M12.12 2a5.544 5.544 0 1 1 0 11.088A5.544 5.544 0 0 1 12.12 2m-.338 3.077c-.701.137-1.318.564-1.318 1.348 0 1.66 2.542 1.294 2.543 2.154 0 .305-.285.564-.81.564-.57 0-1.04-.22-1.41-.525l-.592.654c.439.427 1.048.67 1.587.754v.792h.924v-.807c.809-.168 1.34-.746 1.34-1.446 0-1.69-2.54-1.463-2.541-2.132 0-.275.292-.488.793-.488.455 0 .848.153 1.14.35l.493-.723a2.8 2.8 0 0 0-1.225-.502v-.8h-.924z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default HandDollarIcon
